var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _vm._l(_vm.assessPlan.processes, function (process, idx) {
            return _c("q-chip", {
              key: idx,
              attrs: {
                outline: "",
                square: "",
                removable:
                  _vm.editable &&
                  !_vm.disabled &&
                  process.ramProcessAssessStepCd !== "RPA0000005",
                color: process.selected ? "primary" : "grey-6",
                "text-color": "white",
                icon: "memory",
                selected: process.selected,
                label: process.processName,
                title: process.processName,
              },
              on: {
                "update:selected": [
                  function ($event) {
                    return _vm.$set(process, "selected", $event)
                  },
                  (state) => _vm.selectedProcess(state, process, idx),
                ],
                remove: (state) => _vm.removeProcess(state, process),
              },
              model: {
                value: process.check,
                callback: function ($$v) {
                  _vm.$set(process, "check", $$v)
                },
                expression: "process.check",
              },
            })
          }),
          _vm.editable && !_vm.disabled
            ? _c("q-chip", {
                attrs: {
                  clickable: "",
                  square: "",
                  color: "orange",
                  "text-color": "white",
                  icon: "add",
                  label: _vm.$comm.getLangLabel("LBLADD"),
                  title: _vm.$comm.getLangLabel("LBLADD"),
                },
                on: { click: _vm.addProcess },
              })
            : _vm._e(),
          _vm.editable && !_vm.disabled
            ? _c("q-chip", {
                attrs: {
                  clickable: "",
                  square: "",
                  color: "orange",
                  "text-color": "white",
                  icon: "add",
                  label: _vm.$comm.getLangLabel("LBLADDDIRECTLY"),
                  title: _vm.$comm.getLangLabel("LBLADDDIRECTLY"),
                },
                on: { click: _vm.writeProcess },
              })
            : _vm._e(),
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _c(_vm.processComponent, {
            tag: "component",
            attrs: {
              assessPlan: _vm.assessPlan,
              process: _vm.process,
              disabled: _vm.disabled,
              updateBtnData: _vm.updateBtnData,
              vendorFlag: _vm.vendorFlag,
            },
            on: {
              "update:assessPlan": function ($event) {
                _vm.assessPlan = $event
              },
              "update:assess-plan": function ($event) {
                _vm.assessPlan = $event
              },
              "update:process": function ($event) {
                _vm.process = $event
              },
              "update:disabled": function ($event) {
                _vm.disabled = $event
              },
              "update:updateBtnData": function ($event) {
                _vm.updateBtnData = $event
              },
              "update:update-btn-data": function ($event) {
                _vm.updateBtnData = $event
              },
              "update:vendorFlag": function ($event) {
                _vm.vendorFlag = $event
              },
              "update:vendor-flag": function ($event) {
                _vm.vendorFlag = $event
              },
              saveProcess: _vm.saveProcess,
            },
          }),
        ],
        1
      ),
      _c(
        "q-dialog",
        {
          attrs: { persistent: "" },
          model: {
            value: _vm.processDialog.show,
            callback: function ($$v) {
              _vm.$set(_vm.processDialog, "show", $$v)
            },
            expression: "processDialog.show",
          },
        },
        [
          _c(
            "q-card",
            { staticStyle: { "min-width": "350px" } },
            [
              _c(
                "q-form",
                { ref: "editForm" },
                [
                  _c(
                    "c-card",
                    {
                      staticClass: "cardClassDetailForm",
                      attrs: { title: "LBL0001066" },
                    },
                    [
                      _c(
                        "template",
                        { slot: "card-button" },
                        [
                          _c(
                            "q-btn-group",
                            { attrs: { outline: "" } },
                            [
                              _c("c-btn", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.editable && !_vm.disabled,
                                    expression: "editable&&!disabled",
                                  },
                                ],
                                attrs: { label: "LBLSAVE", icon: "save" },
                                on: { btnClicked: _vm.saveWriteProcess },
                              }),
                              _c("c-btn", {
                                attrs: { label: "LBLCLOSE", icon: "cancel" },
                                on: { btnClicked: _vm.closeDialog },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("template", { slot: "card-detail" }, [
                        _c(
                          "div",
                          { staticClass: "col-12" },
                          [
                            _c("c-text", {
                              attrs: {
                                editable: _vm.editable,
                                disabled: _vm.disabled,
                                label: "LBLPROCESS",
                                name: "processName",
                              },
                              model: {
                                value: _vm.processDialog.processName,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.processDialog,
                                    "processName",
                                    $$v
                                  )
                                },
                                expression: "processDialog.processName",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }